import { PropertyDO } from './property.model';
import { PolicyCoverageDO } from './policyCoverage.model'
import { PropertyAddressDO } from './PropertyAddress.model'

export class PropertyEAppUIDO {

  private id: Number;

  //owner
  public ownerGuid: any = null;
  public ownerId: any = null;
  public ownerNameCd: any = null;
  public ownerGenderCd: any = null;
  public ownerDOB: any = null;
  public ownerRole = "OWNER"
  public ownerAddressList = [];
  public ownerContactList = [];
  public ownerEmailList = [];
  public ownerIdentityList = [];
  public ownerType: any = null;
  public ownerOrganisationName: any = null;
  public ownerContactPersonName: any = null;

  //payer
  public payerGuid: any = null;
  public payerId: any = null;
  public payerNameCd: any = null;
  public payerGenderCd: any = null;
  public payerDOB: any = null;
  public sourceOfIncomeCd: any = null;
  public paymentMethodCd: any = null;
  public paymentFrequencyCd: any = null;
  public payerAccountNumberCd: any = null;
  public accountHolderNameCd: any = null;
  public payerRole = "PAYER"
  public payerAddressList = [];
  public payerContactList = [];
  public payerEmailList = [];
  public payerIdentityList = [];
  public payerOccupationList = [];
  public payerType: any = null;
  public payerOrganisationName: any = null;
  public payerContactPersonName: any = null;

  //coverage
  public policyStartDate: any = null;
  public policyExpiryDate: any = null;
  public term: number = null;
  public discount: any = 0;
  public selectedProduct: any = null;
  public selectedPlan: any = null;
  public package: any = null
  public sumInsured: any = null;
  public finalpremium: any = null;
  public propertyAddressDO: PropertyAddressDO = new PropertyAddressDO();


  public propertyDos: PropertyDO[] = [];
  public proposalCoverages: PolicyCoverageDO[] = [];



}